import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import user from './user';
import loading from './loading';
import menu from './menu';
import collapsed from './collapsed';
import area from './area';

export default history =>
  combineReducers({
    router: connectRouter(history),
    user,
    loading,
    menu,
    collapsed,
    area
  });
